import { render } from "./ContactlistView.vue?vue&type=template&id=1c6525f3"
import script from "./ContactlistView.vue?vue&type=script&lang=js"
export * from "./ContactlistView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__